<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Divider orientation="left" class="text-primary">维保信息</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="零星项目" prop="small_project_id">
                            <Select v-model="Forms.small_project_id" :disabled="is_select" clearable filterable placeholder="零星项目" class="width-100">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.small_project_id">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="维保标题" prop="title">
                            <Input v-model="Forms.title" clearable placeholder="维保标题" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="维保类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable placeholder="维保类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="维保金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="如：10000" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="负责人" prop="head_id">
                            <Select v-model="Forms.head_id" clearable filterable placeholder="负责人" class="width-100">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工人员" prop="work_id">
                            <Select v-model="Forms.work_id" clearable filterable multiple placeholder="施工人员" class="width-100">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开始时间" prop="start_time">
                            <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.start_time" placeholder="开始时间" class="width-100" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="结束时间" prop="end_time">
                            <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.end_time" placeholder="结束时间" class="width-100" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系人" prop="contact_name">
                            <Input v-model="Forms.contact_name" clearable placeholder="联系人" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="contact_mobile">
                            <Input v-model="Forms.contact_mobile" clearable placeholder="联系电话" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="维保说明" prop="m_desc">
                            <Input v-model="Forms.m_desc" type="textarea" :rows="3" clearable placeholder="维保说明" />
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">其他信息</Divider>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="合同" prop="contract">
                            <Input v-model="Forms.contract" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="3" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getMaintainConfig, getMaintainDetail, saveMaintain} from "@/apis/dispersed";

export default {
    name: 'DispersedMaintainCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '创建维保记录',
            isBox : false,
            typeList: [],
            userList: [],
            projectList: [],
            is_select: false,

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                maintain_id: '',
                small_project_id: '',
                title: '',
                type_id: '',
                m_desc: '',
                money: '',
                contact_name: '',
                contact_mobile: '',
                head_id: '',
                work_id: [],
                start_time: '',
                end_time: '',
                contract: '',
                remark: ''
            },
            Rules : {
                small_project_id: [
                    { required: true, type: 'number',  message: '请选择零星项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                title: [
                    { required: true, type: 'string',  message: '请输入维保标题', trigger: 'blur' }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择维保类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入维保金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                head_id: [
                    { required: true, type: 'number',  message: '请选择负责人', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ]
            }
        }
    },
    methods: {
        /**
         功能：合同文件删除
         time: 2026/09/12
         **/
        FileDelete(){
            let that = this;
            that.Forms.contract = '';
        },
        /**
         功能：合同文件下载
         time: 2026/09/12
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.contract){
                //下载文件
                const fileUrl = that.site_url + that.Forms.contract; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：合同文件上传
         time: 2026/09/12
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                that.Forms.contract = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：日期格式化
         time: 2026/09/12
         **/
        formatDate(date){
            if(!date) return '';
            if(typeof date === 'string') return date.substring(0, 10);
            const d = new Date(date);
            const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
            const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            return d.getFullYear() + '-' + month + '-' + day;
        },

        /**
         功能：配置
         time: 2026/09/12
         **/
        GetConfig(){
            let that = this;
            getMaintainConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },

        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(maintain_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getMaintainDetail(maintain_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'type_id' || v === 'head_id' || v === 'maintain_id' || v === 'small_project_id') {
                        that.Forms[v] = data[v] !== '' && data[v] !== null ? parseInt(data[v]) : '';
                    }else if(v === 'work_id'){
                        that.Forms[v] = data.work_list ? data.work_list.map(item => { return parseInt(item.admin_id); }) : [];
                    }else if(v === 'start_time' || v === 'end_time'){
                        that.Forms[v] = data[v] ?? '';
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },

        /**
         功能：添加（可传入项目ID）
         time: 2026/09/12
         **/
        add(small_project_id){
            this.isBox = true;
            this.GetConfig();
            if(small_project_id){
                this.Forms.small_project_id = parseInt(small_project_id);
                this.is_select = true;
            }
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        edit(maintain_id){
            this.isBox = true;
            this.title = '编辑维保记录';
            this.is_select = true;
            this.GetConfig();
            if(maintain_id) this.GetDetail(maintain_id);
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    param.start_time = param.start_time ? that.formatDate(param.start_time) : '';
                    param.end_time = param.end_time ? that.formatDate(param.end_time) : '';
                    that.$store.commit('SET_LOADING' , true);
                    saveMaintain(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '创建维保记录';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                maintain_id: '',
                small_project_id: '',
                title: '',
                type_id: '',
                m_desc: '',
                money: '',
                contact_name: '',
                contact_mobile: '',
                head_id: '',
                work_id: [],
                start_time: '',
                end_time: '',
                contract: '',
                remark: ''
            };
            this.is_select = false;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
